import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {
  Alumno,
  Aula, Autorizacion,
  Aviso,
  Circular,
  Evento,
  Informe,
  ListadoAEAT, Padre, Receipt,
  Recibo,
  SemanaProyecto, Stream, SyncDeltas,
  Vacaciones
} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAppService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** app ***/

  getStatus(): Promise<SyncDeltas> {
    const url = `${this.apiUrl}app/status`;
    return firstValueFrom(this.http.get<SyncDeltas>(url))
  }
  getAlumnosCompleto(): Promise<[Alumno[], Padre, Padre]> {
    const url = `${this.apiUrl}app/alumnos/completo`;
    return firstValueFrom(this.http.get<[Alumno[], Padre, Padre]>(url))
  }
  getInformes (): Promise<Informe[]> {
    const url = `${this.apiUrl}app/informes`;
    return firstValueFrom(this.http.get<Informe[]>(url))
  }
  getEventos (id: number): Promise<(Evento & Circular)[]> {
    const url = `${this.apiUrl}app/eventos/${id}`;
    return firstValueFrom(this.http.get<(Evento & Circular)[]>(url))
  }
  getFotosCurso (curso: string): Promise<(Circular & {nombreAula: string})[]> {
    const url = `${this.apiUrl}app/fotoscurso/${curso}`;
    return firstValueFrom(this.http.get<(Circular & {nombreAula: string})[]>(url))
  }
  getAvisos (idAlumno: number): Promise<Aviso[]> {
    const url = `${this.apiUrl}app/avisos/${idAlumno}`;
    return firstValueFrom(this.http.get<Aviso[]>(url))
  }
  getProgramacion (edad: string, curso: string): Promise<SemanaProyecto[]> {
    const url = `${this.apiUrl}app/programacion/${edad}/${curso}`;
    return firstValueFrom(this.http.get<SemanaProyecto[]>(url))
  }
  getVacaciones (idAlumno: number, curso: string): Promise<Vacaciones> {
    const url = `${this.apiUrl}app/vacaciones/${curso}/${idAlumno}`;
    return firstValueFrom(this.http.get<Vacaciones>(url))
  }
  getRecibos (idAlumno: number): Promise<Receipt[]> {
    const url = `${this.apiUrl}app/recibos/${idAlumno}`;
    return firstValueFrom(this.http.get<Receipt[]>(url))
  }
  // getMatricula (idAlumno: number): Promise<Alumno[]> {
  //   const url = `${this.apiUrl}app/matricula/${idAlumno}`;
  //   return firstValueFrom(this.http.get<Alumno[]>(url))
  // }
  getAutorizaciones (idAlumno: number): Promise<Autorizacion[]> {
    const url = `${this.apiUrl}app/autorizaciones/${idAlumno}`;
    return firstValueFrom(this.http.get<Autorizacion[]>(url))
  }
  // getInformeSinLeer (idAlumno: number): Promise<number> {
  //   const url = `${this.apiUrl}app/informes/${idAlumno}/sinleer`;
  //   return firstValueFrom(this.http.get<number>(url))
  // }
  getUsers (): Promise<Alumno[]> {
    const url = `${this.apiUrl}app/users`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getStreams (): Promise<Stream[]> {
    const url = `${this.apiUrl}app/streams`;
    return firstValueFrom(this.http.get<Stream[]>(url))
  }
  getInformePDF(idAlumno: number, curso: string, trimestre: number): Promise<string> {
    const url = `${this.apiUrl}app/informe/${idAlumno}/${curso}/${trimestre}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getCirculares (aulas: number[]): Promise<Circular[]> {
    const url = `${this.apiUrl}app/circulares`;
    return firstValueFrom(this.http.post<Circular[]>(url, {aulas: aulas}))
  }
  getAulas (aulas: number[]): Promise<Aula[]> {
    const url = `${this.apiUrl}app/aulas`;
    return firstValueFrom(this.http.post<Aula[]>(url, {aulas: aulas}))
  }
  setInformeVisto (idAlumno: number, datos: {curso: string, trimestre: number }): Promise<void> {
    const url = `${this.apiUrl}app/informes/${idAlumno}`;
    return firstValueFrom(this.http.post<void>(url, datos))
  }
  addMatricula (data: {id: number, RGPD: boolean, Fotos: boolean, marketing: boolean, SEPA: boolean, firma: string }): Promise<string> {
    const url = `${this.apiUrl}app/matricula/${data.id}`;
    return firstValueFrom(this.http.put<string>(url, data))
  }
  addSepa (data: {idAlumno: number, firma: string}): Promise<any> {
    const url = `${this.apiUrl}app/sepa/${data.idAlumno}`;
    return firstValueFrom(this.http.put<any>(url, data))
  }
  sendAviso (data: Aviso): Promise<string | number> {
    const url = `${this.apiUrl}app/aviso/${data.child}`;
    return firstValueFrom(this.http.put<string | number>(url, data))
  }
  setTokenPush (token: string): Promise<any> {
    const url = `${this.apiUrl}app/padres/token`;
    return firstValueFrom(this.http.put<any>(url, {token: token}))
  }
  certificadoAnual(idAlumno: number, datos: {nombre: string, recibos: Recibo[], year: number,
    suma: number, fechaEmision: string}): Promise<string> {
    const url = `${this.apiUrl}app/certificado/cuotas/${idAlumno}`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  certificadoAEAT(idAlumno: number, datos: ListadoAEAT): Promise<string> {
    const url = `${this.apiUrl}app/certificado/aeat/${idAlumno}`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  certificadoMatriculacion(datos: {id: number, nombre: string, estado: string,
    falta: string, fbaja: string, fechaEmision: string}): Promise<string> {
    const url = `${this.apiUrl}app/certificado/matriculacion/${datos.id}`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  updateVacaciones(datos: Vacaciones): Promise<void> {
    const url = `${this.apiUrl}app/vacaciones/${datos.idAlumno}`;
    return firstValueFrom(this.http.put<void>(url, datos))
  }
  setAutorizacion(data: {id: number, idAlumno: number, autorizado: boolean, autorizador: string}): Promise<any> {
    const url = `${this.apiUrl}app/autorizacion/${data.idAlumno}`;
    return firstValueFrom(this.http.put<any>(url, data))
  }
  deleteAviso (idAviso: number, idAlumno: number): Promise<any> {
    const url = `${this.apiUrl}app/aviso/${idAlumno}/${idAviso}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
